<!-- 根据根据券模版代码查询券模版信息接口内容 -->
<template>
	<div class="">
		<right-structure :Pdatas='infoData'>
			<pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
			<pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
		</right-structure>
	</div>
</template>

<script>
	import structure from "@/components/commonStructure"

	export default {
		name: '',
		components: {
			'right-structure': structure,
		},
		props: ['commonUrls'],
		data() {
			return {
				requestBody: {
					"couponSn": "5DWIJTB562OEE0Z64IE4"
				},
				responseCode: {
					"data": {

					},
					"message": "业务成功",
					"resultCode": 0,
					"status": 1
				},
				infoData: {
					explain: "第三方接入系统请求智慧停车开放平台根据券模版代码查询券模版信息",
					t_url: this.commonUrls.test + "queryCouponTemplateByCouponSn",
					p_url: this.commonUrls.prod + "queryCouponTemplateByCouponSn",
					precondition: "无",
					fitSystem: "VEMS传统停车场，云停车场",
					pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
					Q_params: [{
						titleName: null,
						tabledata: [{
							tableHead: '参数名',
							tdName: 'info1'
						}, {
							tableHead: '是否必填',
							tdName: 'info2'
						}, {
							tableHead: '类型',
							tdName: 'info3'
						}, {
							tableHead: '说明',
							tdName: 'info4'
						}],
						td: [{
							info1: 'couponSn',
							info2: '是',
							info3: 'String',
							info4: '券编码'
						}, ]
					}],
					R_params: [{
						titleName: 'couponTemplate',
						tabledata: [{
							tableHead: '参数名',
							tdName: 'info1'
						}, {
							tableHead: '是否必填',
							tdName: 'info2'
						}, {
							tableHead: '类型',
							tdName: 'info3'
						}, {
							tableHead: '说明',
							tdName: 'info4'
						}],
						td: [{
								info1: 'name',
								info2: '是',
								info3: 'String',
								info4: '券名称'
							},
							{
								info1: 'code',
								info2: '是',
								info3: 'String',
								info4: '券模板编码，唯一识别'
							},
							{
								info1: 'validFrom',
								info2: '是',
								info3: 'String',
								info4: '券可发放的开始时间，yyyyMMddHHmmss'
							},
							{
								info1: 'validTo',
								info2: '是',
								info3: 'String',
								info4: '券可发放的结束时间，yyyyMMddHHmmss'
							},
							{
								info1: 'validDay',
								info2: '是',
								info3: 'Integer',
								info4: '发券后券的有效分钟数'
							},
							{
								info1: 'couponType',
								info2: '是',
								info3: 'Integer',
								info4: '券类型，0：免费券，车费0元结算 1：金额扣减券，车费减免固定金额结算 2：金额折扣券，车费折扣减免结算 3：金额固定值券，车费按券的固定值结算 4：时间券，时间减免后再按车费结算 5:不同计价券,按不同计价规则车费结算'
							},
							{
								info1: 'faceValue',
								info2: '是',
								info3: 'String',
								info4: '面值，免费券:默认0，金额扣减券:为大于0的正数且保留2位小数，金额折扣券:为0-1且保留2位小数，金额固定券:为大于0的正数且保留2位小数，时间券:为大于0的整数，说明:金额相关的券都以元为单位，时间券以分为单位'
							},
              {
                info1: 'parkCodeList',
                info2: '是',
                info3: 'list',
                info4: '支持使用的车场列表'
              },
						]
					}],
					codeStatus: [{
						titleName: null,
						tabledata: [{
							tableHead: '状态码',
							tdName: 'info1'
						}, {
							tableHead: '说明',
							tdName: 'info2'
						}],
						td: [{
							info1: '000110',
							info2: '失败',
						}, {
							info1: '00110000',
							info2: '失败',
						}, {
							info1: '110000',
							info2: '失败',
						}]
					}],
				}
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/queryCouponTemplateByCouponSn.vue